// extracted by mini-css-extract-plugin
module.exports = {"th-snackbar":"styles_th-snackbar__Zl0ZE","th-snackbar-content":"styles_th-snackbar-content__ZJpnL"};